// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_3L0TG","title":"title_2CX1c","list":"list_3N8L7","item":"item_39vRK","link":"link_YOnXx"};